export default __webpack_public_path__ + "static/media/patients.2af60d4f.svg";